import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import toast from 'react-hot-toast';
import { BeneficiariesService } from '../../../services';
import { classNames, sanitizeToNumbers } from '../../../utils';
import { CheckCircleGreenIcon, CheckCircleOutlinedIcon, CloseIcon, PasswordActive, PasswordInactive } from '../../../assets/icons';

export const CreateBeneficiary = ({ onClose, genders, documentTypes, phoneCodes, relationships, correlativeDni }) => {
  const initialForm = {
    name: '',
    last_name: '',
    gender_id: '',
    dniType: '',
    dni: '',
    phoneCode: '',
    phone: '',
    birthdate: '',
    relationship_id: '',
    email: '',
    mustHaveDni: true,
  };

  const [form, setForm] = useState(initialForm);
  const [isLoading, setIsLoading] = useState(false);
  // const user = useSelector(state => state.user);

  const closeResetingForm = (reloading = false) => {
    setForm(initialForm);
    onClose(reloading);
  }

  const onChange = (value, target) => {
    setForm(state => {
      // if (target === 'birthdate') {
      //   const yearsOld = moment().diff(moment(value), 'years');
      //   if (yearsOld >= 17) return {
      //     ...state,
      //     [target]: value,
      //     dniType: '',
      //     dni: '',
      //     mustHaveDni: true,
      //   };

      //   return {
      //     ...state,
      //     [target]: value,
      //     mustHaveDni: false,
      //     dniType: user.dni ? String(user.dni).substring(0,1) : '',
      //     dni: user.dni ? correlativeDni : '',
      //   }
      // }
      if (target === 'mustHaveDni') {
        return {
          ...state,
          [target]: value,
          dniType: '',
          dni: '',
        }
      }

      return { ...state, [target]: value }
    });
  }

  const isValidForm = (showError = true) => {
    const onError = (msg) => {
      if (showError) toast.error(msg);
      return false;
    }

    if (!form.name)
      return onError('El campo nombre es requerido');

    if (!form.last_name)
      return onError('El campo apellido es requerido');

    if (!form.gender_id)
      return onError('El campo sexo es requerido');

    if (form.mustHaveDni && !form.dniType)
      return onError('El campo tipo de documento es requerido');

    if (form.mustHaveDni && !form.dni)
      return onError('El campo cédula es requerido');

    if (!form.birthdate)
      return onError('El campo fecha de nacimiento es requerido');

    if (!form.relationship_id)
      return onError('El campo fecha de nacimiento es requerido');

    return true;
  }

  const submit = async () => {
    if (!isValidForm()) return;
    setIsLoading(true);

    try {
      const data = {
        ...form,
        birthdate: moment(form.birthdate).format('YYYY-MM-DD'),
      };

      const res = await BeneficiariesService.create(data);
      if (!!res) closeResetingForm(true);

    } catch (error) {
      console.log(error)
    }

    setIsLoading(false);
  }

  const isSubmitEnabled = isValidForm(false);

  return (
    <div className="w-full lg:w-[36rem] bg-white px-4 py-2 rounded-xl">
      <div className="flex justify-between items-center">
        <p className="text-lg text-darkBlue font-semibold text-center">
          Crear Beneficiario
        </p>
        <button onClick={closeResetingForm}>
          <img src={CloseIcon} className="w-3 h-3 object-contain" alt="" />
        </button>
      </div>

      <div className="my-4 flex flex-col lg:grid lg:grid-cols-2 gap-4">
        <Input
          placeholder="Nombre"
          value={form.name}
          onValueChange={v => onChange(v,'name')}
        />

        <Input
          placeholder="Apellido"
          value={form.last_name}
          onValueChange={v => onChange(v,'last_name')}
        />

        <Select
          placeholder="Sexo"
          items={genders}
          value={form.gender_id}
          onValueChange={v => onChange(v,'gender_id')}
        />

        <Input
          type="date"
          placeholder="Fecha de nacimiento"
          value={form.birthdate}
          onValueChange={v => onChange(v,'birthdate')}
        />

        <div
          className="flex justify-between items-center mt-2 hover:cursor-pointer"
          onClick={() => onChange(!form.mustHaveDni, 'mustHaveDni')}
        >
          <p className="text-sm text-blue">¿El beneficiario posee cédula?</p>
          {form.mustHaveDni ? (
            <img src={CheckCircleGreenIcon} className="w-5 h-5 scale-95 object-contain" alt="" />
          ) : (
            <img src={CheckCircleOutlinedIcon} className="w-5 h-5 object-contain brightness-0 opacity-50" alt="" />
          )}
        </div>

        <div className="flex flex-row items-center">
          <div className="w-2/5 [&>div]:rounded-r-none [&>div]:border-r-0">
            <Select
              items={documentTypes}
              value={form.dniType}
              onValueChange={v => onChange(v,'dniType')}
              disabled={!form.mustHaveDni}
            />
          </div>
          <div className="w-3/5 [&>div]:rounded-l-none [&>div]:border-l-0">
            <Input
              placeholder="Cédula"
              value={form.dni}
              onValueChange={v => onChange(sanitizeToNumbers(v),'dni')}
              maxLength={9}
              disabled={!form.mustHaveDni}
            />
          </div>
        </div>

        <div className="flex flex-row items-center">
          <div className="w-2/5 [&>div]:rounded-r-none [&>div]:border-r-0">
            <Select
              items={phoneCodes}
              value={form.phoneCode}
              onValueChange={v => onChange(v,'phoneCode')}
            />
          </div>
          <div className="w-3/5 [&>div]:rounded-l-none [&>div]:border-l-0">
            <Input
              placeholder="Número de teléfono"
              value={form.phone}
              onValueChange={v => onChange(sanitizeToNumbers(v),'phone')}
              maxLength={7}
            />
          </div>
        </div>

        <Select
          placeholder="Parentesco"
          items={relationships}
          value={form.relationship_id}
          onValueChange={v => onChange(v,'relationship_id')}
        />

        <Input
          placeholder="Correo electrónico"
          value={form.email}
          onValueChange={v => onChange(v,'email')}
        />
      </div>

      <button
        className={classNames(
          'rounded-lg w-full text-center h-10 font-bold text-lg my-2 disabled:bg-gray6 disabled:text-gray3',
          isSubmitEnabled ? 'bg-yellow text-black' : 'text-gray bg-gray6'
        )}
        onClick={submit}
        disabled={isLoading}
      >
        <span>Guardar</span>
      </button>
    </div>
  )
}

const Input = ({ type, value, onValueChange, placeholder, maxLength, secureTextEntry, disabled }) => {
	const [isVisible, setIsVisible] = useState(false);
	return (
		<div className="flex items-center gap-x-4 border border-gray3 bg-white rounded-md h-10 w-full px-2">
			<input
				type={secureTextEntry ? (isVisible ? 'text' : 'password') : (type || "text")}
				className="outline-none border-none bg-transparent text-sm w-full"
				placeholder={placeholder}
				value={value}
				onChange={e => onValueChange(e.target.value)}
				maxLength={maxLength}
				disabled={disabled}
			/>
			{secureTextEntry && (
				<button className="focus:outline-none" type="button" onClick={() => setIsVisible(!isVisible)}>
					<img src={isVisible ? PasswordActive : PasswordInactive} className="w-6 h-6" alt="" />
				</button>
			)}
		</div>
	);
}

const Select = ({ defaultValue, items, placeholder, value, onValueChange, disabled }) => {
	return (
		<div className="flex items-center gap-x-4 border border-gray3 bg-white rounded-md h-10 w-full text-sm">
			<select
				className="flex-1 outline-none border-none bg-transparent px-2 mr-2"
				placeholder={placeholder ?? 'Seleccione'}
				defaultValue={defaultValue}
				onChange={e => onValueChange(e.target.value)}
				value={value}
        disabled={disabled}
			>
				<option value="" disabled>{ placeholder ?? 'Seleccione' }</option>
				{items.map((item, index) => (
					<option key={index} value={item.value}>{ item.label }</option>
				))}
			</select>
		</div>
	);
}